var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-json-pretty',{attrs:{"data":_vm.value,"deep":_vm.deep,"showIcon":true,"showDoubleQuotes":true,"showKeyValueSpace":true,"collapsedOnClickBrackets":true,"showLength":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }